import * as React from "react";

const SvgIcon: React.FC<React.SVGProps<SVGElement>> = ({ width = 11, height = 9 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 17 15"
    >
        <path fill="red" d="m8.5 0 8.227 14.25H.273z"></path>
    </svg>
);

export default React.memo(SvgIcon);
